// src/lib/firebase.js
import { variables } from './envars';
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getFunctions, httpsCallable } from 'firebase/functions';
// anywhere early in your client/server init
// import { setLogLevel } from "firebase/firestore";
// setLogLevel("debug"); // for Firestore; similar logging exists for other SDK pieces


import {
	getAuth,
	isSignInWithEmailLink,
	sendSignInLinkToEmail,
	signInWithEmailLink
} from 'firebase/auth';

import { getFirestore, initializeFirestore } from 'firebase/firestore';
import { logError } from './helpers/errors';


const firebaseConfig = {
	apiKey: variables.apiKey,
	authDomain: variables.authDomain,
	databaseURL: variables.databaseURL,
	projectId: variables.projectId,
	storageBucket: variables.storageBucket,
	messagingSenderId: variables.messagingSenderId,
	appId: variables.appId,
	measurementId: variables.measurementId
};

let clientApp = initializeApp(firebaseConfig);

initializeFirestore(clientApp, {
	experimentalAutoDetectLongPolling: true,
});

export const getClientApp = () => {
	if (getApps()?.length) return getApp();

	clientApp = initializeApp(firebaseConfig);

	// const auth = getAuth(clientApp)

	return clientApp;
};

export const isMagicLink = (link) => {
	const auth = getAuth(getClientApp());

	return isSignInWithEmailLink(auth, link);
};

export const signInWithMagicLink = async (email, link) => {
	const auth = getAuth(getClientApp());

	// Fallback for “different device” case
	let finalEmail = email?.trim().toLowerCase();
	if (!finalEmail) {
		finalEmail = localStorage.getItem('emailForSignIn') ||
			prompt('Please confirm the email you used to request this link');
	}

	if (!finalEmail) throw new Error('Email confirmation required');

	const result = await signInWithEmailLink(auth, finalEmail, link);
	localStorage.removeItem('emailForSignIn');   // tidy up
	return result;
};

export const sendMagicLink = (email, redirectUrl) => {
	const auth = getAuth(getClientApp());
	// Normalise once so you reuse *exactly* the same value later
	const normalised = email.trim().toLowerCase();

	const actionCodeSettings = {
		url: redirectUrl,
		handleCodeInApp: true
	};
	return sendSignInLinkToEmail(auth, normalised, actionCodeSettings)
		.then(() => {
			// Make it available if the user opens the link on the same device
			localStorage.setItem('emailForSignIn', normalised);
		});
};

let cachedDb = null;

export const firestoreDb = () => {
	if (cachedDb) {
		return cachedDb;
	}

	try {
		const app = getClientApp();
		cachedDb = getFirestore(app);
		return cachedDb;
	} catch (error) {
		logError(error, 'Error initializing Firestore');
		throw error;
	}
};

// Create functions
export const functions = getFunctions(getClientApp());

export const firestoreAuth = getAuth(getClientApp());

export const rewardDailyVisit = httpsCallable(functions, 'rewardDailyVisit');


// let stripeApp = getClientApp()
// const payments = getStripePayments(stripeApp, {
// 	productsCollection: "plans",
// 	customersCollection: "subscribers",
// });
